/* Muerto de frío – Zusatzfunktionen: Zurück-nach-oben, Newsletter-Popup, "Mehr lesen" in Kategorie-Beschreibung */
(function () {
  'use strict';

  // 1) Zurück nach oben
  var totopBtn = document.querySelector('button[data-mf-totop]');
  document.querySelectorAll('[data-mf-totop]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });
  if (totopBtn) {
    var toggle = function () { totopBtn.hidden = window.scrollY < 700; };
    window.addEventListener('scroll', toggle, { passive: true });
    toggle();
  }

  // 2) Newsletter-Popup: nach X Sekunden auf der Startseite oder bei Exit-Intent (Desktop)
  var popup = document.getElementById('mf-popup');
  if (popup) {
    var KEY = 'mf_popup_seen';
    var seen = false;
    try { seen = Number(localStorage.getItem(KEY)) > Date.now(); } catch (e) {}
    var posted = /customer_posted=true/.test(location.search);
    var open = function () {
      if (popup.hidden === false) return;
      popup.hidden = false;
      var f = popup.querySelector('input[type=email]');
      if (f) f.focus();
      try { localStorage.setItem(KEY, String(Date.now() + 7 * 24 * 3600 * 1000)); } catch (e) {}
    };
    var close = function () { popup.hidden = true; };
    popup.querySelectorAll('[data-mf-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    document.addEventListener('click', function (e) {
  var trigger = e.target.closest('[data-mf-open-newsletter]');
  if (!trigger) return;

  e.preventDefault();
  open();
});
if (posted && popup.querySelector('.mf-popup__ok')) {
      open();
    } else if (!seen) {
      if (popup.dataset.home === '1') {
        setTimeout(open, (parseInt(popup.dataset.delay, 10) || 30) * 1000);
      }
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0 && window.innerWidth > 989) open();
      });
    }
  }

  // 3) Kategorie-Beschreibung einklappen (SEO-Text sichtbar, aber platzsparend)
  var desc = document.querySelector('.collection-hero__description');
  if (desc && desc.scrollHeight > 150) {
    desc.classList.add('mf-clamp');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mf-readmore';
    btn.textContent = 'Mehr lesen';
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      var open = desc.classList.toggle('mf-clamp--open');
      btn.textContent = open ? 'Weniger anzeigen' : 'Mehr lesen';
      btn.setAttribute('aria-expanded', String(open));
    });
    desc.insertAdjacentElement('afterend', btn);
  }
})();
